/**
 * Toast that survives a page reload — for "saved, start the next one" flows.
 *
 * Create pages used to stop on a "… Created!" modal (Add Another = reload,
 * View Details = open it). Now the save goes straight to a fresh form and the
 * confirmation arrives as a toast with a View action:
 *
 *   reloadWithToast("Transfer created", `/internaltransfer/details/${id}`);
 *
 * `<FlashToast />` (mounted once inside the Router in App.js) shows it after
 * the reload. sessionStorage is per tab; a flash older than 30 s is dropped.
 */
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "sonner";

const KEY = "vcpl_flash_toast";
const MAX_AGE_MS = 30_000;

export function reloadWithToast(message, viewPath) {
    try {
        sessionStorage.setItem(KEY, JSON.stringify({ message, viewPath, at: Date.now() }));
    } catch { /* storage blocked: the reload still gives a fresh form */ }
    window.location.reload();
}

export function takeFlashToast() {
    try {
        const raw = sessionStorage.getItem(KEY);
        if (!raw) return null;
        sessionStorage.removeItem(KEY);
        const flash = JSON.parse(raw);
        return flash && Date.now() - flash.at < MAX_AGE_MS ? flash : null;
    } catch {
        return null;
    }
}

export function FlashToast() {
    const history = useHistory();
    useEffect(() => {
        const flash = takeFlashToast();
        if (!flash) return;
        toast.success(flash.message, {
            duration: 8000,
            action: flash.viewPath ? { label: "View", onClick: () => history.push(flash.viewPath) } : undefined,
        });
    }, [history]);
    return null;
}
